/**
 * <dogscan-hero-video> — click-to-play poster → native video.
 * The <template> holds the deferred video markup so it does not load until play.
 * INSTALL: upload this file to the theme's assets/.
 */
if (!customElements.get('dogscan-hero-video')) {
  class DogscanHeroVideo extends HTMLElement {
    connectedCallback() {
      this.play = this.querySelector('.dogscan-hero__play');
      this.template = this.querySelector('template');
      if (!this.play || !this.template) return;
      this.onPlay = this.onPlay.bind(this);
      this.play.addEventListener('click', this.onPlay);
    }

    disconnectedCallback() {
      if (this.play) this.play.removeEventListener('click', this.onPlay);
    }

    onPlay() {
      if (this.classList.contains('is-playing')) return;
      const media = this.template.content.firstElementChild
        ? this.template.content.cloneNode(true)
        : null;
      if (!media) return;
      this.appendChild(media);
      this.classList.add('is-playing');
      const video = this.querySelector('video');
      if (video) {
        video.setAttribute('autoplay', '');
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      }
    }
  }
  customElements.define('dogscan-hero-video', DogscanHeroVideo);
}
